import React, { useEffect } from 'react';

import { Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';

import { AppConfig, AppDesignScheme } from '../../Api';
import ClosedShoppingcart from '../../assets/images/closed_shoppingcart.svg';
import { Async } from '../../Data';
import * as Store from '../../Store';

const useStyles = makeStyles(() => ({
  unavailable: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingTop: '25vh',
  },
  icon: {
    marginBottom: '3vh',
  },
}));

interface StateProps {
  AppConfig: Async<AppConfig>;
  AppDesignScheme: AppDesignScheme;
  isDark: boolean;
  translate: any;
}
type Props = StateProps;

const Unavailable = ({
  AppDesignScheme,
  AppConfig,
  isDark,
  translate,
}: Props) => {
  const classes = useStyles();
  const styles = {
    primary: {
      color: AppDesignScheme.Primary,
    },
    tertiary: {
      color: AppDesignScheme.Tertiary,
    },
  };

  useEffect(() => {
    if (
      AppConfig.status === 'success' &&
      (AppConfig.data.DeliveryEnabled || AppConfig.data.PickupEnabled)
    ) {
      hashHistory.replace('/where');
    }
  }, [AppConfig.status]);

  return (
    <Container className={classes.unavailable}>
      <img
        src={ClosedShoppingcart}
        alt={translate('Closed_shopping_cart')}
        className={classes.icon}
      />
      <Typography
        variant="h1"
        gutterBottom
        align="center"
        style={isDark ? styles.primary : styles.tertiary}
      >
        {translate('Online_ordering_currently_unavailable')}
      </Typography>
      <Typography
        variant="body1"
        align="center"
        style={isDark ? styles.primary : styles.tertiary}
      >
        {translate('Check_back_soon')}
      </Typography>
    </Container>
  );
};

const mapStateToProps = (s: Store.State): StateProps => {
  return {
    AppConfig: s.flipdish.AppConfig,
    AppDesignScheme: s.appDesignScheme,
    isDark: s.flipdish.isDark,
    translate: getTranslate(s.locale),
  };
};

export default connect(mapStateToProps)(Unavailable);
